<template>
  <div id="app">
    <headtop v-if="header_show"></headtop>
    <router-view v-on:header="header" :key="$route.fullpath" />
    <footbottom></footbottom>
  </div>
</template>

<script>
import headtop from "@/components/header";
import footbottom from "@/components/footer";
export default {
  name: "App",
  components: {
    headtop,
    footbottom
  },
  data() {
    return {
      header_show: true
    };
  },
  mounted() {
    localStorage.setItem("user", "");
  },
  methods: {
    header: function(bool) {
      this.header_show = bool;
    }
  },
  watch: {
    $route(e) {
      if (e.name == "register") {
        this.header_show = false;
      } else if (e.name == "login") {
        this.header_show = false;
      } else {
        this.header_show = true;
      }
    }
  }
};
</script>

<style lang="less">
@basecolor: #149508;
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
img {
  vertical-align: top;
  border: none;
}
body {
  background-color: #f6f6f6;
}
div,
ul li {
  box-sizing: border-box;
}
img {
  width: 100%;
  height: 100%;
  vertical-align: middle;
}
.clearf:after,
.clearf:before {
  content: "";
  display: block;
  clear: both;
}
.iconfont {
  vertical-align: middle;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
i {
  font-style: normal;
}
.pagings {
  width: 100%;
  display: -webkit-flex;
  -webkit-justify-content: center;
  -moz-justify-content: center;
  padding: 20px 0;
}

// element样式修改
.el-notification,
.el-message {
  top: 16px !important;
}
.el-carousel__indicators--outside button {
  background-color: #fff;
}
.el-tabs__item {
  font-size: 18px !important;
}
.el-tabs__item.is-active {
  color: #149508 !important;
}
.el-tabs__item:hover {
  color: #149508 !important;
  cursor: pointer !important;
}
.el-tabs__active-bar {
  background-color: #149508 !important;
}
.el-breadcrumb {
  background-color: #fff;
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  padding: 0 15px;
}
.el-breadcrumb__inner.is-link {
  color: #333!important;
  font-weight: normal!important;
  &:hover {
    color: #333!important;
  }
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #149508!important;
  &:hover {
    color: #149508!important;
  }
}
.el-breadcrumb__separator {
  color: #333;
}
.el-pager li.active {
  color: #149508!important;
}
.el-pagination {
  padding: 20px 0;
  margin: 0 auto;
  text-align: center;
}
.el-pager li:hover {
  color: #149508!important;
}
.el-checkbox__label {
  color: #999!important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #149508!important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: #149508!important;
  background-color: #149508!important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #149508!important;
}

.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #149508!important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #149508!important;
  border-color: #149508!important;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #149508!important;
}
.el-checkbox__inner:hover {
  border-color: #149508!important;
}
.el-dialog__title {
  font-size: 28px;
  color: #333;
}
.el-dialog__header {
  border-bottom: 1px solid #e4e4e4;
  margin: 0 25px;
}
.el-dialog__body p {
  font-size: 16px;
  color: #666;
  line-height: 28px;
  height: 500px;
  overflow: auto;
}
// element样式修改
.el-input__inner {
  height: 43px;
  border-radius: 0;
  background: #f6f6f6!important;
}
.el-input__inner:focus {
  border-color: #149508!important;
}
.el-input__inner:hover {
  border-color: #149508!important;
}
.el-button:focus,
.el-button:hover {
  color: #fff!important;
  border-color: #149508!important;
  background-color: #149508!important;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #149508!important;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #149508!important;
  border-color: #149508!important;
}
.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #149508!important;
  outline: 0;
}
.el-pagination__editor.el-input .el-input__inner {
    height: 28px!important;
}
.register-btn {
  width: 326px;
  height: 50px;
  background-color: #149508!important;
  color: #fbfbfb!important;
}
.el-breadcrumb__inner.is-link, .el-breadcrumb__inner a{
  font-weight: normal!important;
}
.telCode{
  padding:0!important;
}
.el-pager li{
  font-size: 16px!important;
}
::-webkit-input-placeholder { /* WebKit browsers */ 
color: #999!important; 
} 
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */ 
color: #999!important; 
} 
::-moz-placeholder { /* Mozilla Firefox 19+ */ 
color: #999!important; 
} 
:-ms-input-placeholder { /* Internet Explorer 10+ */ 
color: #999!important; 
}
</style>



// WEBPACK FOOTER //
// src/App.vue